import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedSizeCodeId = (state: StateSchema): Nullable<string> => state.bookingPage.selectedSizeCodeId;
